import React from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Text, TextProps } from '../../components/text';

export const FormOptionalLabel = forwardRef<TextProps, 'label'>(
  (props: TextProps, ref) => {
    const formOptionalLabelProps = {
      mt: 0,
      ...props,
    };
    return (
      <Text
        size="body-md"
        variant="text-primary"
        ref={ref}
        {...formOptionalLabelProps}
      />
    );
  }
);
